




import Vue from 'vue';
import BulkAddUsersResult from '@/components/bulk-add-users/bulk-add-users-result.component.vue';
export default Vue.extend({
  components: {
    'bulk-add-users-result': BulkAddUsersResult
  }
});
